import { render, staticRenderFns } from "./ConfigBar.vue?vue&type=template&id=01f86e0d&"
import script from "./ConfigBar.vue?vue&type=script&lang=js&"
export * from "./ConfigBar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
